import { IOptions } from "../../types";

export const SITUACAO_OPTIONS: IOptions[] = [
  {
    name: 'Bloquado',
    value: 1
  },
  {
    name: 'Supervisao',
    value: 2
  }
];
